import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useLocale } from 'hooks';

import { AssetActiveIcon, AssetIcon } from 'ui/icons';

import { SidebarProps } from './Sidebar.types';
import { useStyles } from './Sidebar.styles';

export const Sidebar = ({ items, wrapperClassName }: SidebarProps) => {
  const classes = useStyles();
  const { push, location } = useHistory();
  const { formatMessage } = useLocale();

  const handleRouteChange = (route: string | undefined) => () => {
    if (route) {
      push(route);
    }
  };
  return (
    <div className={wrapperClassName}>
      <div className={classes.sidebarContainer} onClick={() => push('/')}>
        <div className={classes.iconContainer}>
          <AssetIcon className={classes.assetIcon} color="inherit" />
          <AssetActiveIcon className={classes.activeIcon} />
        </div>
        <div className={classes.textContainer}>
          <Typography className={classes.firstText}>EasyBat</Typography>
          <Typography className={classes.secondText}>Man</Typography>
        </div>
      </div>
      <List className={classes.list} component="ul">
        {items.map(({ icon: Icon, route, text, onClick }) => {
          const selected = route ? location.pathname.startsWith(route) : false;
          const handleClick = onClick ? onClick : handleRouteChange(route);
          return (
            <ListItem
              className={selected ? classes.selectedListItem : classes.listItem}
              divider
              button
              key={text}
              onClick={handleClick}
            >
              <ListItemIcon className={classes.listIcon}>
                {Icon && <Icon color={selected ? undefined : 'inherit'} className={selected ? 'active' : ''} />}
              </ListItemIcon>
              <ListItemText primary={formatMessage({ id: text })} />
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};
